/**
 * Shopify privacy/cookie banner: fuerza fondo opaco.
 * El banner inyecta estilos dinámicos tarde; CSS del theme a menudo pierde.
 */
(function () {
  var BG = '#0c0c10';
  var STYLE_ID = 'clash-cookie-banner-solid';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '#shopify-pc__banner,',
      '#shopify-pc__banner .shopify-pc__banner__dialog,',
      '.shopify-pc__banner,',
      '.shopify-pc__banner__dialog,',
      '#shopify-pc__banner__dialog,',
      '#shopify-pc__prefs__dialog,',
      '.shopify-pc__prefs__dialog {',
      '  background: ' + BG + ' !important;',
      '  background-color: ' + BG + ' !important;',
      '  background-image: none !important;',
      '  border: 1px solid rgba(255,255,255,0.14) !important;',
      '  box-shadow: 0 16px 48px rgba(0,0,0,0.55) !important;',
      '  backdrop-filter: none !important;',
      '  -webkit-backdrop-filter: none !important;',
      '  opacity: 1 !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__dialog p,',
      '.shopify-pc__banner__dialog p,',
      '.shopify-pc__banner__dialog span {',
      '  color: rgba(243,243,245,0.92) !important;',
      '}'
    ].join('\n');
    document.documentElement.appendChild(s);
  }

  function paint(el) {
    if (!el || el.nodeType !== 1) return;
    el.style.setProperty('background', BG, 'important');
    el.style.setProperty('background-color', BG, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('border', '1px solid rgba(255,255,255,0.14)', 'important');
    el.style.setProperty('box-shadow', '0 16px 48px rgba(0,0,0,0.55)', 'important');
    el.style.setProperty('backdrop-filter', 'none', 'important');
    el.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
    el.style.setProperty('opacity', '1', 'important');
  }

  function styleBanner() {
    ensureStyle();
    document
      .querySelectorAll(
        '#shopify-pc__banner, .shopify-pc__banner, #shopify-pc__banner__dialog, .shopify-pc__banner__dialog, #shopify-pc__prefs__dialog, .shopify-pc__prefs__dialog'
      )
      .forEach(paint);

    var host = document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner');
    if (host && host.firstElementChild) paint(host.firstElementChild);
  }

  function boot() {
    styleBanner();
    new MutationObserver(styleBanner).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    [200, 800, 2000, 4000].forEach(function (ms) {
      setTimeout(styleBanner, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
